export default __webpack_public_path__ + "static/media/wmjordanvideo.3bbff62e.mp4";